import InvoicingAdminCompanyList from "@/pages/invoicingadmin/CompanyList";


const routes = [
  {
    path: "/invoicing-admin/companies",
    name: "Company List",
    component: InvoicingAdminCompanyList,
    meta: {
      breadcrumb: [
        {
          text: "Invoicing Admin",
          disabled: true
        }
      ],
      public: false,
      onlyLoggedOut: false,
      invoicingAdmin: true
    }
  }
];

export default routes;